import React from "react";
import styled from "styled-components/macro";
import { MEDIA_WIDTHS } from "theme";

import { ReactComponent as DropDown } from "../../assets/images/dropdown.svg";
import { ActivatorButton, DropdownList } from "./styles";

const Wrapper = styled.div`
  position: relative;
  background: linear-gradient(73.6deg, rgb(133, 255, 196) 2.11%, rgb(92, 198, 255) 42.39%, rgb(188, 133, 255) 85.72%);
  padding:1px;
  border-radius: 48px;
  
  width: 100%;
  height: 40px;

  border: none;
  
  ${({ theme }) => theme.mediaWidth.upToSmall`
   
  `};
`;
const InnerWrapper = styled.div`
  background: #2F2A3C;
  border-radius: 48px;
`;

const StyledDropDown = styled(DropDown) <{ selected: boolean }>`
  margin: 0 0.25rem 0 0.35rem;
  height: 35%;

  path {
    stroke: ${({ selected, theme }) => (selected ? theme.text1 : theme.white)};
    stroke-width: 1.5px;
  }
`

const NetworkLabel = styled.div`
  flex: 1 1 auto;
  background: linear-gradient(73.6deg, rgb(133, 255, 196) 2.11%, rgb(92, 198, 255) 42.39%, rgb(188, 133, 255) 85.72%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  color: white;
  overflow: hidden;
  height: 24px;
  font-size: 20px;
  white-space: nowrap;
  display: inline-block;
`

const TruncateEllipsis = styled.div`
    display: inline-block;
    font-family: 'Inter custom', sans-serif, monospace;
    vertical-align: bottom;
    white-space: nowrap;
    width: 100%;
`

const SelectorLabel = styled(NetworkLabel)`
  display: none;
  font-size: 19px;
  font-weight: 600;
  line-height: 24px;
  color: white;
  padding-left: 15px;
  @media screen and (min-width: ${MEDIA_WIDTHS.upToSmall}px) {
    display: block;
    margin-right: 8px;
  }
`

const PlaceholderLabel = styled.div`
    padding: 0 10px;
    flex: 1 1 auto;
    background: none;
    display: none;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: white;
    @media screen and (min-width: ${MEDIA_WIDTHS.upToSmall}px) {
        display: block;
        margin-right: 8px;
    }
`

const FlyoutRow = styled.button<{ active: boolean }>`
  align-items: center;
  background: transparent !important;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  font-weight: 400;
  justify-content: space-between;
  padding: 8px 8px;
  text-align: left;
  width: 100%;
  border: none;
`
const ActiveRowWrapper = styled.div`

  //background-color: 'rgb(47 42 60)';

  border-radius: 8px;
  cursor: pointer;
  padding: 0px;
  width: 100%;
`
const FlyoutMenu = styled.div`
  border: none;
  padding: 1px;
  position: absolute;
  border-radius: 20px;
  min-width: 184px;
  z-index: 99;
  background: linear-gradient(73.6deg, rgb(133, 255, 196) 2.11%, rgb(92, 198, 255) 42.39%, rgb(188, 133, 255) 85.72%);
  @media screen and (min-width: ${MEDIA_WIDTHS.upToSmall}px) {

  }
`
const FlyoutMenuContents = styled.div`
  align-items: flex-start;
  background-color: rgb(31 30 34);
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
  0px 24px 32px rgba(0, 0, 0, 0.01);
  border-radius: 20px;
  display: flex;
  width: 255px;
  flex-direction: column;
  font-size: 16px;
  overflow: auto;
  padding: 16px;

  & > *:not(:last-child) {
    margin-bottom: 12px;
  }
`

const truncate = (str: string) => {
    return str.substring(0, 12) + '...' + str.substring(str.length - 4)
}

interface AddressDropdownProps {
    onUserClick: (value: string) => void;
    items?: string[];
    textContent: string;
}

export default function AddressDropdown({
    onUserClick,
    items = [],
    textContent
}: AddressDropdownProps) {
    const activatorRef = React.useRef<HTMLButtonElement | null>(null)
    const listRef = React.useRef<HTMLUListElement | null>(null)
    const [isOpen, setIsOpen] = React.useState(false)
    const [, setActiveIndex] = React.useState(-1)
    const handleClick = () => {
        setIsOpen(!isOpen)
    }

    React.useEffect(() => {
        if (isOpen) {
            document.addEventListener('mouseup', handleClickOutside)
        } else {
            document.removeEventListener('mouseup', handleClickOutside)
        }
        return () => {
            document.removeEventListener('mouseup', handleClickOutside)
        }
    }, [isOpen])

    const handleClickOutside = (event: any) => {
        if (
            listRef.current!.contains(event.target) ||
            activatorRef.current!.contains(event.target)
        ) {
            return
        }
        setIsOpen(false)
    }

    const userClick = (text: string) => {
        onUserClick(text)
        setIsOpen(false)
    }

    function Row({
        active,
        label
    }: {
        active: boolean
        label: string
    }) {
        const rowContent = (
            <FlyoutRow active={active} onClick={() => userClick(label)}>
                <NetworkLabel>
                    <TruncateEllipsis>{truncate(label)}</TruncateEllipsis>
                </NetworkLabel>
            </FlyoutRow>
        )

        if (active) {
            return (
                <ActiveRowWrapper>
                    {rowContent}
                </ActiveRowWrapper>
            )
        }
        return rowContent
    }

    React.useEffect(() => {
        if (!isOpen) {
            setActiveIndex(-1)
        }
    }, [isOpen])

    return (
        <Wrapper>
            <InnerWrapper>
                <ActivatorButton
                    aria-haspopup='true'
                    aria-controls='dropdown1'
                    onClick={handleClick}
                    ref={activatorRef}
                    style={{background: 'transparent', height: 38}}
                    onFocus={() => setActiveIndex(-1)}
                >
                    {
                        textContent === ''
                          ?
                            <PlaceholderLabel>Select an Address</PlaceholderLabel>
                          :
                            <SelectorLabel>{truncate(textContent)}</SelectorLabel>
                    }
                    <StyledDropDown selected={false} />
                </ActivatorButton>

                <DropdownList id='dropdown1' ref={listRef} active={isOpen} role='list'>
                    <FlyoutMenu>
                        <FlyoutMenuContents>
                            {
                                items.map((name) => {
                                    return <Row key={name} active={name === textContent} label={name} />
                                })
                            }
                        </FlyoutMenuContents>
                    </FlyoutMenu>
                </DropdownList>
            </InnerWrapper>
        </Wrapper>
    )
};
